// components
import { Popper, styled } from '@mui/material';
import { PopperProps } from '@mui/material/Popper/BasePopper.types';
import {
  DesktopDatePicker,
  DesktopDatePickerProps
} from '@mui/x-date-pickers-pro';

export const StyledHourManagementDatePicker = styled(
  DesktopDatePicker
)<DesktopDatePickerProps>(({ theme }) => ({
  width: '120px',

  '& .MuiPaper-root': {
    padding: theme.spacing(4, 4, 0, 4)
  },

  '& .MuiInputBase-adornedEnd': {
    paddingRight: theme.spacing(1)
  }
}));

export const StyledDatePickerYearPopper = styled(Popper)<PopperProps>(
  ({ theme }) => ({
    '& .MuiPaper-root': {
      padding: theme.spacing(4, 0)
    },

    '& .MuiDateCalendar-root': {
      height: 'auto'
    }
  })
);
